import React, { useState } from 'react'
import PropertyCard from './property-card'
import 'hover.css'
import { useSelector, useDispatch } from 'react-redux'
import {
  setProperties,
} from '../../actions'
// import { API_KEY } from '../../env'
import axios from 'axios'

function RenderList({ mdColumn, lgColumn, properties, limit = null }) {
  const dispatch = useDispatch()

  const { metaInfo } = useSelector((state) => ({
    metaInfo: state.properties.metaInfo
  }))

  const pagination = Math.ceil(metaInfo.total_count / metaInfo.limit)
  const [page, setPage] = useState(1)

  const pageTo = async (p) => {
    const baseUrl = localStorage.getItem('fetchUrl')
    if (!baseUrl || !metaInfo || !metaInfo.limit) {
      return
    }

    const offset = (p - 1) * metaInfo.limit
    const url = `${baseUrl}&offset=${offset}`
    window.scrollTo({ top: 450, behavior: 'smooth' })
    try {
      const { data } = await axios.get(url)
      dispatch(setProperties(data.objects))
      setPage(p)
    } catch (error) {
      console.error('FETCHING PROPERTIES: ', error)
    }
  }

  if (limit) {
    // ? si la prop "limit" existe hace un slice para reducir el número de elementos
    return properties.slice(0, limit).map((property) => (
      <div
        key={property.id}
        className={`col-10 col-sm-8 col-md-${mdColumn} col-lg-${lgColumn} item`}>
        <PropertyCard {...property} />
      </div>
    ))
  } else {
    return (
      <>
        <div className='row mx-auto justify-content-center justify-content-lg-start'>
          {properties.map((property) => (
            <div
              key={property.id}
              className={`col-10 col-sm-8 col-md-${mdColumn} col-lg-${lgColumn} item`}
            >
              <PropertyCard {...property} />
            </div>
          ))
          }
        </div>
        <div className='row mx-auto justify-content-center justify-content-lg-start'>
          {pagination && pagination > 0 &&
            <nav>
              <ul className="pagination justify-content-end mt-3 mr-4">
                {
                  Array.from(Array(pagination), (element, index) => {
                    return (
                      <li
                        className={`page-item ${(page === index + 1) ? 'active' : ''}`}
                        key={index}
                      >
                        <button
                          type='button'
                          className='page-link'
                          onClick={() => pageTo(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  })
                }
              </ul>
            </nav>
          }
        </div>
      </>
    )
  }
}

function PropertyList(props) {
  return (
    <div className='row'>
      <RenderList {...props} />
    </div>
  )
}

export default PropertyList
